import script from "./new_pdf_comment_form.vue?vue&type=script&setup=true&lang=js"
export * from "./new_pdf_comment_form.vue?vue&type=script&setup=true&lang=js"

import "./new_pdf_comment_form.vue?vue&type=style&index=0&id=ff216e22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff216e22"]])

export default __exports__